import React from "react";
import './Policy_footer.css';

const Policy_footer = () => {
  return (
    <div className="privacy-ap row">
      <div className="privacy-wrap col-xl-12">

        {/* HERO */}
        <section className="privacy-hero">
          <h1>Privacy Policy</h1>
          <p>Your data, your trust — handled with care. At Garshya, privacy is not just a policy. It’s a commitment to protect what matters to you.</p>
          <p>By accessing or using Garshya, you agree to the terms outlined below.</p>
        </section>

        {/* SECTIONS */}
        <section className="privacy-section">
          <h2>1. Information We Collect</h2>
          <ul>
            <li><strong>Personal Information:</strong> Name, phone number, email address, shipping and billing address</li>
            <li><strong>Transaction Information:</strong> Order details, payment status, and purchase history</li>
            <li><strong>Technical Information:</strong> Device type, browser, IP address, and usage data</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>Process and deliver your orders</li>
            <li>Provide customer support and updates</li>
            <li>Improve our website, services, and user experience</li>
            <li>Prevent fraud and ensure platform security</li>
            <li>Comply with legal and regulatory requirements</li>
          </ul>
          <p>We use your data only for legitimate business purposes.</p>

          <h2>3. Payments & Financial Data</h2>
          <ul>
            <li>Payments are processed through secure third-party payment gateways</li>
            <li>Garshya does not store your full card details or sensitive financial data</li>
            <li>Transactions are protected with encryption and authentication layers</li>
          </ul>

          <h2>4. Sharing of Information</h2>
          <ul>
            <li>Logistics partners (for delivery purposes)</li>
            <li>Payment partners (for transaction processing)</li>
            <li>Service providers (for platform operations)</li>
          </ul>
          <p>We do not sell or rent your personal data to third parties.</p>

          <h2>5. Data Protection & Security</h2>
          <ul>
            <li>We use industry-standard security measures to protect your data</li>
            <li>Access to personal data is restricted and monitored</li>
            <li>Regular checks are conducted to prevent unauthorized access</li>
          </ul>

          <h2>6. Data Retention</h2>
          <ul>
            <li>Fulfill your orders</li>
            <li>Comply with legal obligations</li>
            <li>Resolve disputes</li>
          </ul>
          <p>After this, data is securely deleted or anonymized.</p>

          <h2>7. Your Rights</h2>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction or updates</li>
            <li>Request deletion (subject to legal requirements)</li>
            <li>Withdraw consent for certain communications</li>
          </ul>
          <p>To exercise these rights, contact us at: <a href="mailto:privacy@garshya.com" className="privacy-email">privacy@garshya.com</a></p>

          <h2>8. Cookies & Tracking</h2>
          <ul>
            <li>Enhance your browsing experience</li>
            <li>Remember preferences</li>
            <li>Analyze website performance</li>
          </ul>
          <p>You can manage or disable cookies through your browser settings.</p>

          <h2>9. Third-Party Links</h2>
          <p>Our platform may contain links to external websites. Garshya is not responsible for the privacy practices of such third-party platforms.</p>

          <h2>10. Compliance with Indian Laws</h2>
          <p>We process and protect your data in accordance with applicable Indian laws, including data protection and consumer protection regulations.</p>

          <h2>11. Updates to This Policy</h2>
          <p>Garshya may update this Privacy Policy from time to time. Any changes will be reflected on this page with the updated date.</p>

          <h2>12. Contact Us</h2>
          <p>For any questions or concerns regarding privacy: <a href="mailto:support@garshya.com" className="privacy-email">support@garshya.com</a></p>

          <p>At Garshya, privacy isn’t optional. It’s part of the experience we promise.</p>
        </section>

      </div>
    </div>
  );
};

export default Policy_footer;